import { FC } from "react";
import { useMatch } from "react-router";
import { RoutePath } from "src/data/Routes";
import { GLOB } from "src/util/Glob";
import NavigateRoute from "./NavigateRoute";
import { useNavProps } from "./useNavProps";

export const RouteGroup: FC = () => {
  const matchTop = useMatch(RoutePath.MATCH_GROUP_TOP);
  const matchAll = useMatch(RoutePath.MATCH_GROUP_TOP + '/' + RoutePath.MATCH_ITEM_ONLY);
  const navProps = useNavProps(search => {
    const match = matchAll || matchTop;
    const cls = match.params.class;
    let group = decodeURI(match.params.group);
    let type = match.params.type;
    let item = matchAll?.params.item;
    const groups = GLOB.menuService.storagesBy.group;
    if (!type && groups.children?.some(mn => mn.pageType === group)) {
      item = group;
      group = null;
    } else if (!item) {
      item = type;
      type = null;
    }
    return { clsName: cls, allType: RoutePath.GROUP, groupName: group, typeOrDevice: type, itemName: item, search };
  }, [matchTop?.params, matchAll?.params]);

  return navProps && <NavigateRoute {...navProps} />;
};
